import CashCollectionReverseDepositRequestBase from './base/CashCollectionReverseDepositRequestBase';

/**
 * @class CashCollectionReverseDepositRequest
 * @extends CashCollectionReverseDepositRequestBase
 */
class CashCollectionReverseDepositRequest extends CashCollectionReverseDepositRequestBase {

}

export default CashCollectionReverseDepositRequest;
